module.exports = __webpack_public_path__ + "img/logo.b39809f.svg";